import { useParams } from "react-router-dom";
import { isTaskAddPhoto } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { AddPhotoPage } from "./AddPhotoPage";

const AddPhoto = () => {
    const { marketId, taskId } = useParams();

    const { tasks } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[safeMarketId]?.[safeTaskId];

    if (!currentTask || !isTaskAddPhoto(currentTask)) return <NotFound />;

    return <AddPhotoPage marketId={safeMarketId} task={currentTask} />;
};

export default AddPhoto;
